module.exports = __webpack_public_path__ + "img/104.9b220896.jpg";